import { render, staticRenderFns } from "./BlackFridayRoadblock.vue?vue&type=template&id=7a19756c&scoped=true&"
import script from "./BlackFridayRoadblock.vue?vue&type=script&lang=js&"
export * from "./BlackFridayRoadblock.vue?vue&type=script&lang=js&"
import style0 from "./BlackFridayRoadblock.vue?vue&type=style&index=0&id=7a19756c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a19756c",
  null
  
)

export default component.exports